import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { SectionHeader } from '../../wrappers/sectionHeader/SectionHeader';
import { H2 } from '../../../typography/semanticTags';
import { SixSixArticleList } from './SixSixArticleList';
import { sectionStyle } from '../pageLayouts/layout.utils';
import { CardComponentDataProps } from '../../partials/cards/cards.utils';

interface HeaderWithSixSixArticleListProps {
  title: string;
  cardsProps: CardComponentDataProps[];
}

export const HeaderWithSixSixArticleList: React.FunctionComponent<HeaderWithSixSixArticleListProps> = ({ title, cardsProps }) => {
  return (
    <section className={css(sectionStyle)}>
      <SectionHeader linkText={null} href={null}>
        <H2>{title}</H2>
      </SectionHeader>
      <SixSixArticleList cardsProps={cardsProps} />
    </section>
  );
};
